import React from 'react';
import { Icon } from 'hfs-common-ui';
import FormattedMessageWrapper from '~/components/views/FormattedMessageWrapper/FormattedMessageWrapper';
import { PortalModal } from '~/components/views/common/styled/Modal/Modal';
import * as S from './styled';

interface Props {
  status?: number;
  description: string;
  values?: any;
  clearError(): void;
}

const UnhandledErrorModalV2 = (props: Props) => {
  const handleConfirm = () => {
    props.clearError();
  };

  return (
    <PortalModal
      showCloseIcon={true}
      isOpen={true}
      onClose={handleConfirm}
      actionButtons={[
        {
          label: { key: 'web.error.button.confirm' },
          onClick: handleConfirm,
          variant: 'primary',
          key: 'unhandledErrorConfirm',
        },
      ]}
      id="unhandledErrorModal"
    >
      <S.Content>
        <S.ErrorContainer>
          <S.IconWrapper>
            <Icon type="notification.error" color="error" size="large" />
          </S.IconWrapper>
          <S.Status>{props.status}</S.Status>
          <S.Description>
            <FormattedMessageWrapper langKey={props.description} values={props.values} />
          </S.Description>
        </S.ErrorContainer>
      </S.Content>
    </PortalModal>
  );
};

export default UnhandledErrorModalV2;
